import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Reveal, SectionHeading } from "./Reveal";
import { FAQS } from "../data/content";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="noise-overlay relative bg-navy-950 py-24 lg:py-32">
    <div className="mx-auto max-w-4xl px-4 sm:px-8 lg:px-16">
      <SectionHeading
        overline="Questions, Answered"
        testId="faq-heading"
        title={
          <>
            Everything you're <span className="text-gold-metallic italic">wondering</span>
          </>
        }
      />

      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="mt-14 w-full">
          {FAQS.map((faq, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-b border-white/8">
              <AccordionTrigger
                data-testid={`faq-trigger-${i + 1}`}
                className="py-6 text-left font-display text-lg sm:text-xl font-medium text-slate-100 transition-colors hover:text-gold-soft hover:no-underline [&[data-state=open]]:text-gold-soft"
              >
                {faq.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i + 1}`}
                className="pb-6 text-sm sm:text-base leading-relaxed text-slate-400"
              >
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
